module.exports = __webpack_public_path__ + "exo-latin-300.21d8997134cbc12e5153.svg";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/typeface-exo/files/exo-latin-300.svg
// module id = ../../../../typeface-exo/files/exo-latin-300.svg
// module chunks = styles